import { GamesRequestParams } from '../types/GamesRequestParams';

export default (params: GamesRequestParams) =>
  (params.username != null && params.username != '') ||
  params.color != null ||
  params.result != null ||
  params.platform != null ||
  params.opening != null ||
  params.timeControl != null ||
  params.from != null ||
  params.to != null ||
  params.ratingFrom != null ||
  params.ratingTo != null ||
  params.pattern != null ||
  params.speed != null ||
  params.repair != null ||
  params.pgn != null ||
  params.onlyStarred === true;
